<template>
    <div>
        <material-card class="card-tabs" color="green">
            <v-flex slot="header">
                <v-tabs
                    v-model="activeTab"
                    color="transparent"
                    slider-color="white"
                >
                    <span
                        class="subheading font-weight-light mr-3"
                        style="align-self: center"
                        >Transactions:</span
                    >
                    <v-tab class="mr-3" href="#transactions">
                        Payments
                    </v-tab>
                    <v-tab class="mr-3" href="#gifts">
                        Gifts
                    </v-tab>
                    <v-tab class="mr-3" href="#tracking">
                        Tracking
                    </v-tab>
                    <v-tab class="mr-3" href="#hours">
                        Hours
                    </v-tab>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="activeTab == 'transactions'"
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0"
                        @click="openNewPaymentDialog"
                        >Add Payment</v-btn
                    >
                    <v-btn
                        v-if="activeTab == 'gifts'"
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0"
                        @click="openNewGiftDialog"
                        >Add Gift</v-btn
                    >
                    <v-btn
                        v-if="activeTab == 'tracking'"
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0"
                        @click="openNewTrackDialog"
                        >Add Tracking</v-btn
                    >
                    <v-btn
                        v-if="activeTab == 'hours'"
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0"
                        @click="openAddHoursDialog(null)"
                        >Add Hours</v-btn
                    >
                </v-tabs>
            </v-flex>

            <v-progress-linear
                v-if="loading"
                :indeterminate="true"
                color="success"
            ></v-progress-linear>

            <v-tabs-items v-model="activeTab" v-if="!loading">
                <v-tab-item
                    v-for="tab in [
                        'transactions',
                        'gifts',
                        'tracking',
                        'hours',
                    ]"
                    :key="tab"
                    :value="tab"
                >
                    <v-card v-if="!getTabList().length">
                        <v-card-text
                            class="text-xs-center"
                            v-text="emptyCardText()"
                        ></v-card-text>
                    </v-card>
                    <v-expansion-panel
                        v-if="activeTab == 'transactions'"
                        class="expansion-panel-margin"
                    >
                        <v-expansion-panel-content
                            class=""
                            v-for="transaction in transactions.filter(
                                (t) => t.year == setup.currentYear,
                            )"
                        >
                            <template v-slot:header class="my-0">
                                <div>
                                    <div class="subheading mb-1">
                                        {{ transaction.date | date }}
                                    </div>
                                    <div class="text--disabled subheading">
                                        {{
                                            transaction.confirmed
                                                ? "CONFIRMED"
                                                : "NOT CONFIRMED"
                                        }}
                                    </div>
                                </div>
                                <v-spacer></v-spacer>
                                <div
                                    v-if="transaction.missingAmount"
                                    class="text-danger subheading text-xs-center"
                                >
                                    Missing:
                                    {{ transaction.missingAmount | currency }}
                                </div>
                                <v-spacer></v-spacer>
                                <div class="text-xs-right pr-3 subheading">
                                    <div class="mb-1">
                                        {{ transaction.amount | currency }}
                                    </div>
                                    <div
                                        class="text--disabled"
                                        v-if="transaction.paymentType"
                                    >
                                        {{
                                            transaction.paymentType.toUpperCase() +
                                                (transaction.cardNumLast4
                                                    ? " - " +
                                                      transaction.cardNumLast4
                                                    : "")
                                        }}
                                    </div>
                                </div>
                            </template>
                            <v-card class="pl-1 mt-3">
                                <v-flex xs12 class="ml-3 pl-3">
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Date:
                                        </div>
                                        <div>
                                            {{ transaction.date | date }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Entrered On:
                                        </div>
                                        <div>
                                            {{ transaction.enteredOn | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Amount:
                                        </div>
                                        <div>
                                            {{ transaction.amount | currency }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="px-3 py-2"
                                        v-if="transaction.missingAmount"
                                    >
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Missing Amount:
                                        </div>
                                        <div class="text-danger">
                                            ({{
                                                transaction.missingAmount
                                                    | currency
                                            }})
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Confirmed:
                                        </div>
                                        <div>
                                            {{
                                                transaction.confirmed
                                                    ? "Yes"
                                                    : "No"
                                            }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Payment Type:
                                        </div>
                                        <div>
                                            {{ transaction.paymentType }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Entrered By:
                                        </div>
                                        <div>
                                            {{ transaction.entreredBY }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Updated On:
                                        </div>
                                        <div>
                                            {{ transaction.updatedOn | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Updated By:
                                        </div>
                                        <div>
                                            {{ transaction.updatedBY }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="px-3 py-2"
                                        v-if="transaction.note"
                                    >
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Note:
                                        </div>
                                        <div>
                                            {{ transaction.note }}
                                        </div>
                                    </v-layout>
                                    <v-card-actions class="mb-2">
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            small
                                            dark
                                            color="warning"
                                            class="mr-1"
                                            @click="
                                                openDeletePaymentDialog(
                                                    transaction,
                                                )
                                            "
                                        >
                                            Delete
                                        </v-btn>
                                        <v-btn
                                            small
                                            dark
                                            color="default"
                                            @click="
                                                openEditPaymentDialog(
                                                    transaction,
                                                )
                                            "
                                        >
                                            Edit
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                        v-if="activeTab == 'gifts'"
                        class="expansion-panel-margin"
                    >
                        <v-expansion-panel-content
                            class=""
                            v-for="gift in gifts"
                        >
                            <template v-slot:header class="my-0">
                                <div>
                                    <div class="subheading mb-1">
                                        {{ gift.dateEntered | time }}
                                    </div>
                                    <div class="text--disabled subheading">
                                        {{
                                            gift.isPickedUp
                                                ? "PICKED UP"
                                                : "NOT PICKED UP"
                                        }}
                                    </div>
                                </div>
                                <v-spacer></v-spacer>
                                <div class="subheading text-xs-right pr-3">
                                    <div class="mb-1">
                                        {{ getGiftName(gift) }}
                                    </div>
                                    <div class="text--disabled">
                                        {{ gift.quantity }}
                                    </div>
                                </div>
                            </template>
                            <v-card class="pl-1 mt-3">
                                <v-flex xs12 class="ml-3 pl-3">
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Date:
                                        </div>
                                        <div>
                                            {{ gift.dateEntered | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Quantity:
                                        </div>
                                        <div>
                                            {{ gift.quantity }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Order Number:
                                        </div>
                                        <div>
                                            {{ gift.orderNumber }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Note:
                                        </div>
                                        <div>
                                            {{ gift.notes }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Entered By:
                                        </div>
                                        <div>
                                            {{ gift.enteredBy }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Picked Up:
                                        </div>
                                        <div>
                                            {{ gift.isPickedUp ? "Yes" : "No" }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Updated On:
                                        </div>
                                        <div>
                                            {{ gift.dateLastUpdated | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Updated By:
                                        </div>
                                        <div>
                                            {{ gift.lastUpdatedBy }}
                                        </div>
                                    </v-layout>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            small
                                            dark
                                            color="warning"
                                            @click="openDeleteGiftDialog(gift)"
                                        >
                                            Delete
                                        </v-btn>
                                        <v-btn
                                            small
                                            dark
                                            color="default"
                                            @click="openEditGiftDialog(gift)"
                                        >
                                            Edit
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                        v-if="activeTab == 'tracking'"
                        class="expansion-panel-margin"
                    >
                        <v-expansion-panel-content
                            class=""
                            v-for="track in trackingDetails"
                        >
                            <template v-slot:header class="my-0">
                                <div>
                                    <div class="subheading mb-1">
                                        {{ track.enteredOn | time }}
                                    </div>
                                    <!-- <div class="text--disabled subheading">
                                        Test
                                    </div> -->
                                </div>
                                <v-spacer></v-spacer>
                                <div class="subheading text-xs-right pr-3">
                                    <div class="mb-1">
                                        {{ getTrackingName(track) }}
                                    </div>
                                    <div class="text--disabled">
                                        {{ track.data }}
                                    </div>
                                </div>
                            </template>
                            <v-card class="pl-1 mt-3">
                                <v-flex xs12 class="ml-3 pl-3">
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Entered On:
                                        </div>
                                        <div>
                                            {{ track.enteredOn | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Details:
                                        </div>
                                        <div>
                                            {{ track.data }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Entered By:
                                        </div>
                                        <div>
                                            {{ track.entreredBY }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Updated On:
                                        </div>
                                        <div>
                                            {{ track.updatedOn | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Updated By:
                                        </div>
                                        <div>
                                            {{ track.updatedBY }}
                                        </div>
                                    </v-layout>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            small
                                            dark
                                            color="warning"
                                            @click="
                                                openDeleteTrackDialog(track)
                                            "
                                        >
                                            Delete
                                        </v-btn>
                                        <v-btn
                                            small
                                            dark
                                            color="default"
                                            @click="openEditTrackDialog(track)"
                                        >
                                            Edit
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                        v-if="activeTab == 'hours'"
                        class="expansion-panel-margin"
                    >
                        <v-expansion-panel-content
                            class=""
                            v-for="hour in groupHours"
                        >
                            <template v-slot:header class="my-0">
                                <div>
                                    <div class="subheading mb-1">
                                        {{ hour.enteredOn | time }}
                                    </div>
                                </div>
                                <v-spacer></v-spacer>
                                <div class="subheading text-xs-right pr-3">
                                    <div class="mb-1">
                                        {{ getGroupName(hour) }}
                                    </div>
                                    <div class="text--disabled">
                                        Hours: {{ hour.hours }}
                                    </div>
                                </div>
                            </template>
                            <v-card class="pl-1 mt-3">
                                <v-flex xs12 class="ml-3 pl-3">
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Entered On:
                                        </div>
                                        <div>
                                            {{ hour.enteredOn | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Hours:
                                        </div>
                                        <div>{{ hour.hours }}</div>
                                    </v-layout>
                                    <v-layout row class="px-3 py-2">
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Entered By:
                                        </div>
                                        <div>
                                            {{ hour.entreredBY }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="px-3 py-2"
                                        v-if="hour.updatedOn"
                                    >
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Updated On:
                                        </div>
                                        <div>
                                            {{ hour.updatedOn | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="px-3 py-2"
                                        v-if="hour.updatedBY"
                                    >
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Updated By:
                                        </div>
                                        <div>
                                            {{ hour.updatedBY }}
                                        </div>
                                    </v-layout>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            small
                                            dark
                                            color="warning"
                                            @click="
                                                openDeleteGroupHourDialog(hour)
                                            "
                                        >
                                            Delete
                                        </v-btn>
                                        <v-btn
                                            small
                                            dark
                                            color="default"
                                            @click="openAddHoursDialog(hour)"
                                        >
                                            Edit
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-tab-item>
            </v-tabs-items>
        </material-card>

        <v-dialog persistent v-model="newPaymentDialog" max-width="400">
            <new-payment
                :closeNewPaymentDialog="closeNewPaymentDialog"
                :student="student"
                :payment="editPayment"
                :reload="reload"
                :getDomain="getDomain"
                :setup="setup"
            ></new-payment>
        </v-dialog>

        <v-dialog persistent v-model="newGiftDialog" max-width="400">
            <new-gift
                :closeNewGiftDialog="closeNewGiftDialog"
                :student="student"
                :gift="editGift"
                :reload="reload"
                :transactions="transactions"
                :getDomain="getDomain"
                :setup="setup"
                :giftSetups="setup.giftSetups"
            ></new-gift>
        </v-dialog>

        <v-dialog persistent v-model="addHourDialog" max-width="400">
            <add-hours
                :closeHoursDialog="closeHoursDialog"
                :student="student"
                :hour="editHours"
                :reload="reload"
                :getDomain="getDomain"
                :setup="setup"
                :groupSetups="setup.groupSetups"
            ></add-hours>
        </v-dialog>

        <v-dialog persistent v-model="newTrackDialog" max-width="400">
            <new-track
                :closeNewTrackDialog="closeNewTrackDialog"
                :student="student"
                :track="editTrack"
                :reload="reload"
                :getDomain="getDomain"
                :setup="setup"
                :trackSetups="setup.trackSetups"
            ></new-track>
        </v-dialog>

        <v-dialog v-model="deletePaymentDialog" max-width="400">
            <v-card class="pa-2" v-if="paymentToDelete">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2"
                    >This will delete the payment of
                    {{ paymentToDelete.amount | currency }}</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deletePaymentDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="deleting"
                        color="success"
                        @click="deletePayment"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteGiftDialog" max-width="400">
            <v-card class="pa-2" v-if="giftToDelete">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2"
                    >This will delete the gift:
                    {{ getGiftName(giftToDelete) }}</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteGiftDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="deleting"
                        color="success"
                        @click="deleteGift"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteTrackDialog" max-width="400">
            <v-card class="pa-2" v-if="trackToDelete">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2"
                    >This will delete the track:
                    {{ getTrackingName(trackToDelete) }}</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteTrackDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="deleting"
                        color="success"
                        @click="deleteTrack"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteHoursDialog" max-width="400">
            <v-card class="pa-2" v-if="groupHoursToDelete">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2"
                    >This will delete {{ groupHoursToDelete.hours }} hours from
                    Group:
                    {{ " " + getGroupName(groupHoursToDelete) }}</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteHoursDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="deleting"
                        color="success"
                        @click="deleteHours"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import newPayment from "./PurimNewPayment.vue";
import newGift from "./PurimNewGift.vue";
import newTrack from "./PurimNewTrack.vue";
import addHours from "./PurimAddHours.vue";

export default {
    props: {
        transactions: Array,
        gifts: Array,
        trackingDetails: Array,
        student: Object,
        setup: Object,
        reload: Function,
        getDomain: Function,
        groupHours: Array,
        loading: Boolean,
    },
    components: {
        newPayment,
        newGift,
        newTrack,
        addHours,
    },
    data() {
        return {
            activeTab: "transactions",

            newPaymentDialog: false,
            newGiftDialog: false,
            newTrackDialog: false,
            deletePaymentDialog: false,
            deleteGiftDialog: false,
            deleteTrackDialog: false,
            deleteHoursDialog: false,
            addHourDialog: false,
            deleting: false,

            paymentToDelete: null,
            giftToDelete: null,
            trackToDelete: null,
            groupHoursToDelete: null,
            editPayment: null,
            editGift: null,
            editTrack: null,
            editHours: null,
        };
    },
    async created() {},
    watch: {},
    computed: {},
    methods: {
        emptyCardText() {
            const tab = this.activeTab.substring(
                this.activeTab.lastIndexOf("-") + 1,
            );

            switch (tab) {
                case "transactions":
                    return "No Payments";
                case "gifts":
                    return "No Gifts";
                case "tracking":
                    return "No Tracking";
                case "hours":
                    return "No Group Hours";
            }
        },
        getTabList() {
            switch (this.activeTab) {
                case "transactions":
                    return this.transactions.filter(
                        (t) => t.year == this.setup.currentYear,
                    );
                case "gifts":
                    return this.gifts;
                case "tracking":
                    return this.trackingDetails;
                case "hours":
                    return this.groupHours;
            }
        },
        getGiftName(gift) {
            const setup = this.setup.giftSetups.find(
                (g) => g.giftID == gift.giftID,
            );

            return setup.description;
        },
        getTrackingName(track) {
            const setup = this.setup.trackSetups.find(
                (g) => g.code == track.code,
            );

            return setup.description;
        },
        getGroupName(hour) {
            const setup = this.setup.groupSetups.find(
                (g) => g.groupID == hour.groupID,
            );

            return setup.groupName;
        },
        openNewPaymentDialog() {
            this.editPayment = null;
            this.newPaymentDialog = true;
        },
        closeNewPaymentDialog() {
            this.newPaymentDialog = false;
        },
        openEditPaymentDialog(payment) {
            this.editPayment = payment;
            this.newPaymentDialog = true;
        },
        openDeletePaymentDialog(payment) {
            this.paymentToDelete = payment;
            this.deletePaymentDialog = true;
        },
        openNewGiftDialog() {
            this.editGift = null;
            this.newGiftDialog = true;
        },
        closeNewGiftDialog() {
            this.newGiftDialog = false;
        },
        closeHoursDialog() {
            this.addHourDialog = false;
        },
        openEditGiftDialog(gift) {
            this.editGift = gift;
            this.newGiftDialog = true;
        },
        openDeleteGiftDialog(gift) {
            this.giftToDelete = gift;
            this.deleteGiftDialog = true;
        },
        openNewTrackDialog() {
            this.editTrack = null;
            this.newTrackDialog = true;
        },
        openAddHoursDialog(hour) {
            this.editHours = hour;
            this.addHourDialog = true;
        },
        closeNewTrackDialog() {
            this.newTrackDialog = false;
        },
        openEditTrackDialog(track) {
            this.editTrack = track;
            this.newTrackDialog = true;
        },
        openDeleteTrackDialog(track) {
            this.trackToDelete = track;
            this.deleteTrackDialog = true;
        },
        openDeleteGroupHourDialog(hours) {
            this.groupHoursToDelete = hours;
            this.deleteHoursDialog = true;
        },
        async deletePayment() {
            this.deleting = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/transactions/delete",
                    this.paymentToDelete,
                );

                this.deleting = false;
                this.deletePaymentDialog = false;

                this.reload();
            } catch (e) {
                this.deleting = false;
            }
        },
        async deleteGift() {
            this.deleting = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/deleteGift",
                    this.giftToDelete,
                );

                this.deleting = false;
                this.deleteGiftDialog = false;

                this.reload();
            } catch (e) {
                this.deleting = false;
            }
        },
        async deleteTrack() {
            this.deleting = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/deleteTrack",
                    this.trackToDelete,
                );

                this.deleting = false;
                this.deleteTrackDialog = false;

                this.reload();
            } catch (e) {
                this.deleting = false;
            }
        },
        async deleteHours() {
            this.deleting = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/deleteHours",
                    this.groupHoursToDelete,
                );

                this.deleting = false;
                this.deleteHoursDialog = false;

                this.reload();
            } catch (e) {
                this.deleting = false;
            }
        },
    },
};
</script>
<style>
.expansion-panel-margin .v-expansion-panel__header {
    margin-top: 5px;
    margin-bottom: 5px;
}
.v-expansion-panel__header {
    height: 63px;
}
</style>
